import styled from 'react-emotion';
import {ellipsis} from 'polished';

export default styled('div')({
  ...ellipsis(),

  // Prevent `overflow: hidden` from adding extra height to inline-block elements
  verticalAlign: 'top'
});



// WEBPACK FOOTER //
// ./src/components/Ellipsis/Ellipsis.tsx